import { createFileRoute } from "@tanstack/react-router";

/** The log is mounted by the parent layout; this leaf only owns the path and its metadata. */
export const Route = createFileRoute("/deliveries/")({
  head: () => ({
    meta: [
      { title: "Data feed log — LevelLoad" },
      { name: "description", content: "Feed arrival and processing history in LevelLoad." },
      { property: "og:title", content: "Data feed log — LevelLoad" },
      { property: "og:description", content: "Feed arrival and processing history in LevelLoad." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return null;
}
